export default __webpack_public_path__ + "static/media/06-2.66e8b50b.jpg";